import { DEBUG } from "./config";
import { getBackendData, sendBackendData } from "./xhrbackend";
export class Util {
    static urlEncode(value) {
        return encodeURIComponent(value);
    }
    constructor() { }
    static getCNfromParentDN(dn) {
        if (dn != null && typeof dn != 'undefined') {
            const regex = /cn=([^,]+)/;
            const match = dn.match(regex);
            if (match && match[1]) {
                return match[1];
            }
        }
        return "standard";
    }
    static number2money(amount, currency) {
        const formattedAmount = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
        return formattedAmount;
    }
    static string2IsoString(timeString) {
        if (timeString == null || timeString == "") {
            return null;
        }
        try {
            const parts = timeString.split('.');
            let result = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`).toISOString();
            return result;
        }
        catch (e) {
            console.log("error on converting time Input");
            return "";
        }
    }
    static getDurationFromInput(duration) {
        if (duration < 11) {
            if (Util.DEBUG)
                console.log("-->Minuten", duration);
            return duration * 5;
        }
        else if (duration <= 35) {
            if (Util.DEBUG)
                console.log("-->Stunden", duration);
            return (duration - 10) * 60;
        }
        else if (duration <= 63) {
            if (Util.DEBUG)
                console.log("-->Tage", duration);
            return (duration - 33) * 60 * 24;
        }
        else {
            if (Util.DEBUG)
                console.log("-->Monate", duration);
            const month = (duration - 62);
            let days = 0;
            switch (month) {
                case 1:
                    days = 31;
                    break;
                case 2:
                    days = 59;
                    break;
                case 3:
                    days = 90;
                    break;
                case 4:
                    days = 120;
                    break;
                case 5:
                    days = 151;
                    break;
                case 6:
                    days = 181;
                    break;
                case 7:
                    days = 212;
                    break;
                case 8:
                    days = 243;
                    break;
                case 9:
                    days = 273;
                    break;
                case 10:
                    days = 304;
                    break;
                case 11:
                    days = 334;
                    break;
                case 12:
                    days = 365;
                    break;
                default:
                    days = 365 + 30 * (month - 12);
            }
            return days * 60 * 24;
        }
    }
    static getDuration4Print(duration) {
        if (Util.DEBUG)
            console.log("-->getDuration4Print", duration);
        if (duration == 1) {
            return "1 Minute";
        }
        else if (duration < 60) {
            if (Util.DEBUG)
                console.log("-->Minuten", duration);
            return `${duration} Minuten`;
        }
        else if (duration == 60) {
            if (Util.DEBUG)
                console.log("-->Stunden", duration);
            return `${duration / 60} Stunde`;
        }
        else if (duration < 60 * 24) {
            if (Util.DEBUG)
                console.log("-->Stunden", duration);
            return `${duration / 60} Stunden`;
        }
        else if (duration == 60 * 24) {
            if (Util.DEBUG)
                console.log("-->Tage", duration);
            return `${duration / 60 / 24} Tag`;
        }
        else {
            if (Util.DEBUG)
                console.log("-->Tage", duration);
            return `${duration / 60 / 24} Tage`;
        }
    }
    static isoString2DateString(timestamp) {
        if (typeof timestamp === "undefined")
            return "-";
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return `${day}.${month}.${year}`;
    }
    static isoString2TimeString(timestamp) {
        if (typeof timestamp === "undefined")
            return "-";
        const date = new Date(timestamp);
        const hour = date.getHours().toString().padStart(2, "0");
        const min = date.getMinutes().toString().padStart(2, "0");
        const sec = date.getSeconds().toString().padStart(2, "0");
        return `${hour}:${min}:${sec}`;
    }
    static unixTimestamp2DateString(timestamp) {
        if (typeof timestamp === "undefined")
            return "-";
        const date = new Date(Number(timestamp));
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return `${day}.${month}.${year}`;
    }
    static timeStamp2TimeString(timestamp) {
        const date = new Date(timestamp);
        const hour = date.getHours();
        const minutes = date.getMinutes();
        return `${hour}:${(minutes + 100).toString().substring(1, 3)}`;
    }
    static timeStamp2DayString(timestamp) {
        const date = new Date(timestamp);
        const day = date.getDate();
        const month = date.getUTCMonth() + 1;
        return `${day}.${month}.`;
    }
    static ldapTimestring2Timestamp(ldapTimestamp) {
        const year = Number(ldapTimestamp.substring(0, 4));
        const month = Number(ldapTimestamp.substring(4, 6));
        const day = Number(ldapTimestamp.substring(6, 8));
        const hour = Number(ldapTimestamp.substring(8, 10));
        const minute = Number(ldapTimestamp.substring(10, 12));
        const second = Number(ldapTimestamp.substring(12, 14));
        const date = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
        return date.toISOString();
    }
    static getLinkWithReplacements(odAppLocation, myJSON) {
        console.log("--> getLinkWithReplacements", myJSON);
        if (myJSON && odAppLocation.indexOf("{") >= 0) {
            let result = odAppLocation.replace("{email}", myJSON.mail);
            result = result.replace('{surname}', myJSON.surname);
            result = result.replace('{name}', myJSON.name);
            result = result.replace('{username}', myJSON.username);
            return result;
        }
        else {
            if (Util.DEBUG)
                console.log("no replacment", odAppLocation);
            return odAppLocation;
        }
    }
    static replaceWithPlaceholder(odAppLocation, myJSON) {
        console.log("--> replaceWithPlaceholder", myJSON);
        try {
            if (myJSON && odAppLocation.indexOf("{") >= 0) {
                let result = odAppLocation.replace("{pupil.odClassName}", myJSON.pupil.odClassName);
                return result;
            }
            else {
                if (Util.DEBUG)
                    console.log("no replacment", odAppLocation);
                return odAppLocation;
            }
        }
        catch (e) {
            return odAppLocation;
        }
    }
    static getStandortLabel(standort) {
        if (Util.DEBUG)
            console.log("-->getStandortLabel", standort);
        return `${standort.Name1} / ${standort.Stras} / ${standort.Ort01}`;
    }
    static generateRandomDomId() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    static filterActiveClasses(classes) {
        return classes.filter(classItem => !classItem.bis || new Date(classItem.bis) > new Date());
    }
    static debounce(func, wait) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }
    static getSelectOptions(models) {
        let result = [];
        for (let i = 0; i < models.length; i++) {
            result.push({
                value: models[i],
                label: models[i]
            });
        }
        return result;
    }
    static replaceHTMLTags(textInput) {
        return textInput.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    static replaceEscapedHTMLTags(textInput) {
        return textInput.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
    }
    static formatTitle(odApp) {
        return odApp.odAppTitle.replace(/([^#]*)(#.+)$/, "$1<span class='rudi-title-part'>$2</span>");
    }
    static formatTitleByString(name) {
        return name.replace(/([^#]*)(#.+)$/, "$1<span class='rudi-title-part'>$2</span>");
    }
    static saveColorChange(username, userPreferences, app, color, bearerToken) {
        if (!userPreferences.settings)
            userPreferences.settings = [];
        const setting = userPreferences.settings.find(element => element.cn === app.cn);
        if (setting) {
            setting.color = color;
        }
        else {
            userPreferences.settings.push({ cn: app.cn, color: color });
        }
        if (DEBUG)
            console.log("saveColorChange: ", userPreferences.settings);
        Util.saveUserPreferences(username, userPreferences, bearerToken);
    }
    static saveUserPreferences(username, userPreferences, bearerToken) {
        sendBackendData('', `/users/${username.toLowerCase()}/settings`, "PUT", 'application/json', bearerToken, userPreferences, (response) => {
        });
    }
    static getRudiColorFromCallList(cssClassList) {
        for (let item of cssClassList) {
            if (item.startsWith('rudi-color'))
                return item;
        }
        throw new Error("No rudi-color found in class list");
    }
    static getNextRudiColor(currentColor) {
        if (currentColor == "")
            return 'rudi-color-0';
        else {
            let value = Number(currentColor.charAt(currentColor.length - 1));
            if (value == 9)
                return "";
            else
                value++;
            return 'rudi-color-' + value;
        }
    }
    static userId2DisplayName(store, end_user_id, domIDUserName, username, bearerToken) {
        const domNode = document.getElementById(domIDUserName);
        if (domNode) {
            if (store.nameKeyUser.has(end_user_id)) {
                domNode.innerHTML = store.nameKeyUser.get(end_user_id);
            }
            else {
                getBackendData('', `/users/${username}/queryuser?cn=${end_user_id}&searchdn=ou=rummelsberg,ou=people,dc=open-diakonie,dc=de`, 'GET', 'application/json', bearerToken, (response) => {
                    console.log("got response", response.target.response);
                    const users = JSON.parse(response.target.response);
                    if (users && users[0]) {
                        store.nameKeyUser.set(users[0].cn, users[0].displayName);
                        domNode.innerHTML = users[0].displayName;
                    }
                });
            }
        }
    }
    static userOtId2DisplayName(store, end_user_id, domIDUserName, userid, bearerToken) {
        const domNode = document.getElementById(domIDUserName);
        if (domNode) {
            if (store.nameKeyOtObject.has(end_user_id)) {
                domNode.innerHTML = store.nameKeyUser.get(end_user_id);
            }
            else {
                domNode.innerHTML = "Loading...";
            }
        }
    }
    static getAppByCN(collection, cn) {
        for (const appGroup of collection.apps) {
            for (const app of appGroup.children) {
                if (app.cn === cn)
                    return app;
            }
        }
        throw new Error("App not found");
    }
    static getValueOfDivInput(node) {
        if (node.classList.contains('od-value') && node.getAttribute('value')) {
            return node.getAttribute('value');
        }
        else {
            return node.innerHTML;
        }
    }
    static enableValidationErrorMessage(input, message) {
        const messageNode = document.querySelector(`#${input.getAttribute('id')}-invalid`);
        if (messageNode) {
            messageNode.innerHTML = message;
            messageNode.classList.remove('disabled');
        }
        else {
            console.log("Not Found");
        }
        input.classList.add('invalid');
    }
    static disableValidationErrorMessage(input) {
        const messageNode = document.querySelector(`#${input.getAttribute('id')}-invalid`);
        if (messageNode) {
            messageNode.classList.add('disabled');
        }
        input.classList.remove('invalid');
    }
    static logMessage(bearerToken, sessionId, appCN, action, target) {
        const data = {
            "message": {
                "action": action,
                "target": target,
                "app": appCN,
                "session": sessionId
            }
        };
        sendBackendData('', `/log/interaction/`, "POST", 'application/json', bearerToken, data, (response) => {
        });
    }
    static sortOtNameKeyObjectByLabel(results, getLabel) {
        return results.sort((a, b) => {
            const labelA = getLabel(a).toLowerCase();
            const labelB = getLabel(b).toLowerCase();
            if (labelA < labelB)
                return -1;
            if (labelA > labelB)
                return 1;
            return 0;
        });
    }
    static isResponseData(obj) {
        return typeof obj === 'object' &&
            obj !== null &&
            'code' in obj &&
            typeof obj.code === 'number' &&
            'body' in obj;
    }
    static userHasRole(userResponse, role) {
        if (!userResponse || !userResponse.apps)
            return false;
        for (const appGroup of userResponse.apps) {
            if (appGroup.cn === role)
                return true;
            if (appGroup.children) {
                for (const app of appGroup.children) {
                    if (app.cn === role)
                        return true;
                }
            }
        }
        return false;
    }
}
Util.version = '1';
Util.DEBUG = false;
